<script setup lang="ts">
import { OrSelectV3, SelectItem } from '@onereach/ui-components';

defineProps<{
  customersOptions: SelectItem[];
  internalMode: boolean;
}>();

const model = defineModel<string>();
</script>

<template>
  <div
    v-if="!model && internalMode"
    class="w-full h-full flex flex-col items-center justify-center gap-md"
  >
    <div class="xs:w-full w-[480px] flex flex-col items-center gap-sm">
      <span class="typography-headline-2 text-center">
        {{ $t('customerWrapper.title') }}
      </span>
      <span class="text-outline typography-body-2-regular text-center">
        {{ $t('customerWrapper.description') }}
      </span>
    </div>
    <OrSelectV3
      v-model="model"
      :options="customersOptions"
      :placeholder="$t('activity.SelectCustomer')"
      class="w-[352px] xs:w-full"
      enable-search
      enable-clear
    />
  </div>
  <template v-else>
    <slot />
  </template>
</template>
